import React, { CSSProperties, createRef, useEffect, useState } from 'react';
import styles from './Loading.module.css';
import FadeTransition from '@monofe/ui-common/transition/FadeTransition';

export interface ILoadingProps {
    styleOverrides?: CSSProperties;
}

enum StyleElem {
    Container = 'Container',
    Text = 'Text',
}

const DEFAULTS: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.Text]: {},
};

const PROPS_APPLICATOR: Record<StyleElem, (props: ILoadingProps) => CSSProperties> = {
    [StyleElem.Container]: (props: ILoadingProps) => ({
        ...props.styleOverrides,
    }),
    [StyleElem.Text]: (props: ILoadingProps) => ({}),
};

export function classNameForElement(element: StyleElem, props: ILoadingProps): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad ?? '';
}

export function styleForElement(elem: StyleElem, props: ILoadingProps): CSSProperties {
    const style = Object.assign({}, DEFAULTS[elem], PROPS_APPLICATOR[elem](props));

    return style;
}

function _LoadingText(index: number) {
    let text = 'Loading';

    for (let i = 0; i < index; i++) {
        text += '.';
    }

    return text;
}

function Loading(props: ILoadingProps): JSX.Element {
    const style = (elem: StyleElem) => styleForElement(elem, props);
    const className = (elem: StyleElem) => classNameForElement(elem, props);
    const [loadCounter, setLoadCounter] = useState<number>(0);

    const ref = createRef<HTMLElement>();

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoadCounter(val => (val > 8 ? 0 : val + 1));
        }, 800);

        return () => clearTimeout(timeout);
    });
    return (
        <FadeTransition
            key="Loading"
            className={className(StyleElem.Container)}
            style={style(StyleElem.Container)}
        >
            <span ref={ref} className={className(StyleElem.Text)} style={style(StyleElem.Text)}>
                {_LoadingText(loadCounter)}
            </span>
        </FadeTransition>
    );
}

export default Loading;
